<template lang="pug">
 el-form(
     label-width="120px",
     :model="userInfo",
     ref="userInfo",
     :rules="userInfoRules"
 )
    el-form-item(
      label="Tên đăng nhập",
      prop="account"
    )
      el-input.col-10(v-model="userInfo.account", name="name")
    el-form-item(
      label="Mật khẩu",
      prop="password"
    )
      el-input.col-10(v-model="userInfo.password", type="password", name="password")
    el-form-item.mb0
      .col-10
        el-button.col-12(type="danger", @click="handleLogin", :loading="loading") Đăng nhập
        a.right(href="javascript:;", @click="handleLoginButton('signup')") Đăng ký
</template>

<script>
import Vue from 'vue'
import Q from 'q'
import { Form, FormItem, Button, Input, Message } from 'element-ui'

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Input)

export default {
  name: 'login',
  data () {
    return {
      loading: false,
      userInfo: {
        account: '',
        password: ''
      },
      userInfoRules: {
        account: [
          { required: true, message: 'Nhập tên đăng nhập', trigger: 'blur' },
          { min: 5, message: 'Tên đăng nhập giới hạn từ 5-20 ký tự', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Nhập mật khẩu', trigger: 'blur' },
          { min: 5, max: 20, message: 'Mật khẩu giới hạn từ 5-20 ký tự', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLoginButton (stat) {
      this.$bus.emit('getLoginStat', stat)
    },
    handleLogin () {
      this.loading = true
      Q.fcall(this.validateForm)
        .then(this.ajaxLogin)
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    validateForm (formName = 'userInfo') {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          throw new Error('validate Error')
        }
        return
      })
    },
    ajaxLogin () {
      this.$axios({
        url: '/vn/login',
        method: 'post',
        data: { ...this.userInfo }
      })
        .then(res => {
          if (res.data.ret === 0) {
            this.$bus.emit('getLoginStat', '')
            this.$bus.emit('getUserInfo', this.userInfo)
          } else {
            throw new Error(res.data.msg)
          }
        })
        .catch(err => {
          this.loading = false
          Message({
            message: err.message,
            type: 'warning'
          })
        })
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// login.vue?7dc82f32